import { cn } from '../../lib/utils';

const variants = {
  brand:   'bg-brand-50    text-brand-700   ring-1 ring-inset ring-brand-200/60 dark:bg-brand-900/40 dark:text-brand-300 dark:ring-brand-700/40',
  neutral: 'bg-ink-100     text-ink-700     ring-1 ring-inset ring-ink-200/60   dark:bg-ink-800     dark:text-ink-300   dark:ring-ink-700/60',
  success: 'bg-success-light  text-success-dark ring-1 ring-inset ring-success/20 dark:bg-success/15  dark:text-success    dark:ring-success/30',
  warning: 'bg-warning-light  text-warning-dark ring-1 ring-inset ring-warning/20 dark:bg-warning/15  dark:text-warning    dark:ring-warning/30',
  danger:  'bg-danger-light   text-danger-dark  ring-1 ring-inset ring-danger/20  dark:bg-danger/15   dark:text-danger     dark:ring-danger/30',
  info:    'bg-info-light     text-info-dark    ring-1 ring-inset ring-info/20    dark:bg-info/15     dark:text-info       dark:ring-info/30',
  outline: 'bg-transparent text-ink-700 ring-1 ring-inset ring-ink-300 dark:text-ink-300 dark:ring-ink-700',
};

const sizes = {
  sm: 'h-5 px-1.5 text-2xs gap-1',
  md: 'h-6 px-2   text-xs  gap-1.5',
  lg: 'h-7 px-2.5 text-sm  gap-1.5',
};

export default function Badge({
  className,
  variant = 'neutral',
  size = 'md',
  dot = false,
  children,
  ...props
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center rounded-full font-semibold whitespace-nowrap tracking-tightish',
        variants[variant],
        sizes[size],
        className,
      )}
      {...props}
    >
      {dot && (
        <span className={cn(
          'w-1.5 h-1.5 rounded-full',
          variant === 'success' && 'bg-success',
          variant === 'warning' && 'bg-warning',
          variant === 'danger'  && 'bg-danger',
          variant === 'info'    && 'bg-info',
          variant === 'brand'   && 'bg-brand-500',
          variant === 'neutral' && 'bg-ink-500',
          variant === 'outline' && 'bg-ink-500',
        )} />
      )}
      {children}
    </span>
  );
}
